/**
 * Durations as the day view shows them (section 11.0 mockup): "14m", "2h 05m",
 * "8h". Rounded to the nearest minute; anything shorter than half a minute
 * but not zero is "<1m", so a short call never reads as nothing.
 */
export function formatDuration(seconds: number): string {
  if (seconds > 0 && seconds < 30) {
    return "<1m";
  }
  const minutes = Math.round(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) {
    return `${String(rest)}m`;
  }
  if (rest === 0) {
    return `${String(hours)}h`;
  }
  return `${String(hours)}h ${String(rest).padStart(2, "0")}m`;
}

/** Hours as a duration: 8 is "8h", 7.5 is "7h 30m". */
export function formatHours(hours: number): string {
  return formatDuration(Math.round(hours * 3600));
}
